var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/pages/default_page.tsx";
import React from 'react';
import LinkFooter from 'soapbox/features/ui/components/link_footer';
import BundleContainer from 'soapbox/features/ui/containers/bundle_container';
import { WhoToFollowPanel, TrendsPanel, SignUpPanel, PromoPanel } from 'soapbox/features/ui/util/async-components';
import { useAppSelector, useFeatures } from 'soapbox/hooks';
import { Layout } from '../components/ui';
const DefaultPage = ({
  children
}) => {
  const me = useAppSelector(state => state.me);
  const features = useFeatures();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Layout.Main, {
    className: "",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 7
    }
  }, children), /*#__PURE__*/React.createElement(Layout.Aside, {
    className: "",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 7
    }
  }, !me && /*#__PURE__*/React.createElement(BundleContainer, {
    fetchComponent: SignUpPanel,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 11
    }
  }, Component => /*#__PURE__*/React.createElement(Component, {
    key: "sign-up-panel",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 27
    }
  })), features.trends && /*#__PURE__*/React.createElement(BundleContainer, {
    fetchComponent: TrendsPanel,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 11
    }
  }, Component => /*#__PURE__*/React.createElement(Component, {
    limit: 3,
    key: "trends-panel",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 27
    }
  })), /*#__PURE__*/React.createElement(BundleContainer, {
    fetchComponent: PromoPanel,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 9
    }
  }, Component => /*#__PURE__*/React.createElement(Component, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 25
    }
  })), features.suggestions && /*#__PURE__*/React.createElement(BundleContainer, {
    fetchComponent: WhoToFollowPanel,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40,
      columnNumber: 11
    }
  }, Component => /*#__PURE__*/React.createElement(Component, {
    limit: 5,
    key: "wtf-panel",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 27
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "grow",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(LinkFooter, {
    key: "link-footer",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45,
      columnNumber: 9
    }
  })));
};
export default DefaultPage;